// Make sure to prefix the mutation names with the module to avoid collisions
export const DOCUMENT_SET_FOLDER = 'documentSetFolder'
export const DOCUMENT_SET_TOP_LEVEL_FOLDERS = 'documentSetTopLevelFolders'
export const DOCUMENT_SET_PENDING_SHARE_COUNTS = 'documentSetPendingShareCounts'

export const DOCUMENT_CLOSE_CREATE_FOLDER_MODAL = 'documentCloseCreateFolderModal'
export const DOCUMENT_OPEN_CREATE_FOLDER_MODAL = 'documentOpenCreateFolderModal'

export const DOCUMENT_CLOSE_UPLOAD_DOCUMENT_MODAL = 'documentCloseUploadDocumentModal'
export const DOCUMENT_OPEN_UPLOAD_DOCUMENT_MODAL = 'documentOpenUploadDocumentModal'

export const DOCUMENT_OPEN_DELETE_FOLDER_MODAL = 'documentOpenDeleteFolderModal'
export const DOCUMENT_CLOSE_DELETE_FOLDER_MODAL = 'documentCloseDeleteFolderModal'

export const DOCUMENT_OPEN_DELETE_DOCUMENT_MODAL = 'documentOpenDeleteDocumentModal'
export const DOCUMENT_CLOSE_DELETE_DOCUMENT_MODAL = 'documentCloseDeleteDocumentModal'

export const DOCUMENT_OPEN_MOVE_DOCUMENT_MODAL = 'documentOpenMoveDocumentModal'
export const DOCUMENT_CLOSE_MOVE_DOCUMENT_MODAL = 'documentCloseMoveDocumentModal'

export const DOCUMENT_OPEN_REPLACE_DOCUMENT_MODAL = 'documentOpenReplaceDocumentModal'
export const DOCUMENT_CLOSE_REPLACE_DOCUMENT_MODAL = 'documentCloseReplaceDocumentModal'

export const DOCUMENT_OPEN_DOCUMENT_HISTORY_MODAL = 'documentOpenDocumentHistoryModal'
export const DOCUMENT_CLOSE_DOCUMENT_HISTORY_MODAL = 'documentCloseDocumentHistoryModal'

export const DOCUMENT_OPEN_SEND_TO_GROUPS_MODAL = 'documentOpenSendToMembershipGroupsModal'
export const DOCUMENT_CLOSE_SEND_TO_GROUPS_MODAL = 'documentCloseSendToMembershipGroupsModal'

export const DOCUMENT_OPEN_SEND_TO_MEMBERS_MODAL = 'documentOpenSendToMembershipsModal'
export const DOCUMENT_CLOSE_SEND_TO_MEMBERS_MODAL = 'documentCloseSendToMembershipsModal'

export const DOCUMENT_OPEN_SEND_TO_ORGANIZATIONS_MODAL = 'documentOpenSendToOrganizationsModal'
export const DOCUMENT_CLOSE_SEND_TO_ORGANIZATIONS_MODAL = 'documentCloseSendToOrganizationsModal'

export const DOCUMENT_OPEN_EDIT_FOLDER_MODAL = 'documentOpenEditFolderModal'
export const DOCUMENT_CLOSE_EDIT_FOLDER_MODAL = 'documentCloseEditFolderModal'

export const DOCUMENT_OPEN_EDIT_DOCUMENT_MODAL = 'documentOpenEditDocumentModal'
export const DOCUMENT_CLOSE_EDIT_DOCUMENT_MODAL = 'documentCloseEditDocumentModal'

export const DOCUMENT_OPEN_REJECT_SHARED_ITEM_MODAL = 'documentOpenRejectSharedItemModal'
export const DOCUMENT_CLOSE_REJECT_SHARED_ITEM_MODAL = 'documentCloseRejectSharedItemModal'

export const DOCUMENT_SET_FAVORITE_DOCUMENTS = 'documentSetFavoriteDocuments'